import yaml from 'js-yaml'

const defaults: yaml.DumpOptions = {
  // Line wrapping inside the `perform` block often used `>+` which means single linebreaks are collapsed into one line
  // and double linebreaks are collapsed into single linebreaks (which makes working with the output code much harder)
  lineWidth: -1,
  noRefs: true
}

export default function dump(input: unknown, options?: yaml.DumpOptions) {
  return yaml.dump(input, { ...defaults, ...options })
}
